export const REQUEST_TYPE = {
  CREATE: 'create',
  GET: 'get',
  UPDATE: 'update',
  DELETE: 'delete',
};
